import { useEffect, useRef } from "react";
import type { Stage } from "../types";

export function useScrollToActiveStage(
  activeStageId: string,
  performances: any[],
  stages: Stage[],
  isScrollingRef: React.RefObject<boolean>,
  shouldScroll = true,
) {
  // Disable scroll tracking on mount to let layout settle and initial scroll finish
  useEffect(() => {
    const timer = setTimeout(() => {
      if (isScrollingRef.current !== undefined) {
        (isScrollingRef as any).current = false;
      }
    }, 800);
    return () => clearTimeout(timer);
  }, [isScrollingRef]);

  // Handle initial scroll to active stage section once it renders in DOM
  const initialScrollDoneRef = useRef(false);
  useEffect(() => {
    if (!shouldScroll || initialScrollDoneRef.current || !activeStageId || activeStageId === "all")
      return;

    const timer1 = setTimeout(() => {
      const element = document.getElementById(`stage-section-${activeStageId}`);
      if (element) {
        initialScrollDoneRef.current = true;
        if (isScrollingRef.current !== undefined) {
          (isScrollingRef as any).current = true;
        }
        element.scrollIntoView({ behavior: "auto" });
        setTimeout(() => {
          if (isScrollingRef.current !== undefined) {
            (isScrollingRef as any).current = false;
          }
        }, 300);
      }
    }, 300);

    return () => {
      clearTimeout(timer1);
    };
  }, [activeStageId, performances, stages, shouldScroll, isScrollingRef]);
}
